import { AgTechWebApplicationInfo } from "@agtech/web/application/AgTechWebApplication";
import AgTechSideNavigationMenu from "@agtech/web/components/App/Templates/App/Navigation/Controls/AgTechSideNavigationMenu";
import SaleSelectionDropdown from "../areas/sales/components/dropdowns/SaleSelectionDropdown";
import AgTechSideNavigationButton from "@agtech/web/components/App/Templates/App/Navigation/Controls/AgTechSideNavigationButton";
import SaleContactMasterDetailDialog from "../areas/contacts/dialogs/master/SaleContactMasterDetailDialog";
import SaleSettingsViewDialog from "../areas/sales/dialogs/SaleSettingsViewDialog";
import OperationSideNavigationInfo from "@agtech/web/integrations/operation/info/OperationSideNavigationInfo";
import ReportsDialog from "../areas/reports/dialogs/ReportsDialog";

export type SalesAppSideNavigationMenuProps = {
    app: AgTechWebApplicationInfo
}

const SalesAppSideNavigationMenu = (props: SalesAppSideNavigationMenuProps) => {
    return (
        <AgTechSideNavigationMenu
            app={props.app}
            width="w-[280px]"
            content={isCollapsed => (
                <>
                    {!isCollapsed && (
                        <div className="row-based p-6 bg-slate-700 border-b border-t border-slate-600 flex">
                            <OperationSideNavigationInfo />
                            <SaleSelectionDropdown classes="mt-8" />
                        </div>
                    )}
                    <div className="row-based flexed pt-6 pb-2 flex">
                        <div className="mt-6 mb-2 row-based flex">
                            <AgTechSideNavigationButton
                                {...SaleContactMasterDetailDialog.ButtonProps()}
                                isCollapsed={isCollapsed}
                            />
                            {/*<AgTechSideNavigationButton
                                {...SaleHistoryViewDialog.ButtonProps}
                                role={'Admin'}
                                isCollapsed={isCollapsed}
                            />*/}
                            <AgTechSideNavigationButton
                                {...ReportsDialog.ButtonProps}
                                isCollapsed={isCollapsed}
                            />
                            <AgTechSideNavigationButton
                                {...SaleSettingsViewDialog.ButtonProps}
                                isCollapsed={isCollapsed}
                            />
                        </div>
                    </div>
                </>
            )}
        />
    );
}

export default SalesAppSideNavigationMenu;